
export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    size: {
      // 二维码尺寸
      type: Number,
      default: 90
    },
    text: {
      // 二维码内容
      type: String,
      default: ''
    }
  },
  data() {
    return {
      qr: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      try {
        console.log('this.text', this.text)
        const QRCode = window.QRCode
        this.qr = new QRCode(this.index != 0 ? `qrcode-${this.index}` : 'qrcode', {
          text: this.text,
          width: this.size,
          height: this.size,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode?.CorrectLevel?.Q
        })
      } catch (err) {
        this.$fxlog(`QRCode生成异常,${err}`)
      }
      if (document.getElementById('qrcode')) {
        document.getElementById('qrcode').title = ''
      }
    })
  },
  methods: {
    test(dataUrl, id) {},
    setresetting(url) {
      if (this.qr) {
        // 如果二维码对象已存在，则更新链接
        this.qr.clear() // 清除之前的二维码
        this.qr.makeCode(url) // 生成新的二维码
        if (document.getElementById('qrcode')) {
          document.getElementById('qrcode').title = ''
        }
      } else {
        // 如果二维码对象不存在，则创建新的二维码对象
        try {
          const QRCode = window.QRCode
          this.qr = new QRCode(this.index != 0 ? `qrcode-${this.index}` : 'qrcode', {
            text: this.text,
            width: this.size,
            height: this.size,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode?.CorrectLevel?.Q
          })
        } catch (err) {
          this.$fxlog(`QRCode生成异常,${err}`)
        }
        if (document.getElementById('qrcode')) {
          document.getElementById('qrcode').title = ''
        }
      }
    }
  }
}
